import React, { useCallback } from 'react';
import AlterDomainBR from '@/media/onboarding/temporary-domain-br.png';
import AlterDomainES from '@/media/onboarding/temporary-domain-es.webp';
import { DomainNotRegisteredProps } from './DomainNotRegistered.types';
import { isBRServer } from '@/utils/Validators/validation';
import * as Styles from './DomainNotRegistered.styles';
import { IconCheck } from 'gatorcomponents';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';

const DomainNotRegistered = ({
  locales,
  buttonsProps,
  domain,
  currentFlow,
  FLOWS,
  hasMultDomainPlans,
}) => {
  const stepProps = useCallback(() => {
    const customButtonsProps = {
      ...buttonsProps,
      rightButton: [
        ...buttonsProps.rightButton,
      ],
    };

    if (currentFlow === FLOWS.SITE_BUILDER || !hasMultDomainPlans) {
      customButtonsProps.rightButton.splice(0, 1);
    }

    return {
      imageSrc: isBRServer ? AlterDomainBR : AlterDomainES,
      buttonsProps: customButtonsProps,
      testId: 'domain-not-registered-step',
    };
  }, [
    buttonsProps,
    currentFlow,
    FLOWS.SITE_BUILDER,
    hasMultDomainPlans,
  ]);

  return (
    <>
      <GenericStep {...stepProps()}>
        <Styles.Title>{locales.title(domain)}</Styles.Title>
        <Styles.Description>{locales.description}</Styles.Description>
        <Styles.Subtitle>{locales.subtitle}</Styles.Subtitle>

        <Styles.List>
          {locales.list.map(item => (
            <Styles.ListItem key={item}>
              <IconCheck color="primaryMedium" />
              {item}
            </Styles.ListItem>
          ))}
        </Styles.List>
      </GenericStep>
    </>
  );
};

DomainNotRegistered.propTypes = DomainNotRegisteredProps;

export default DomainNotRegistered;
